// src/prototype/data/mockOpportunities.ts
// ============================================================
// DEPRECATED: This file now re-exports from demoOpportunities.ts
// 
// All data comes from BigQuery Golden Demo (client_id=200)
// This file exists solely for backward compatibility with existing imports.
// 
// NO FALLBACK DATA: If there's an issue with demoOpportunities.ts,
// you will see a clear error. This is intentional - we want to know
// about data issues immediately rather than silently falling back.
// 
// UPDATED: January 2026 - Golden Demo Integration
// UPDATED: March 2026 - Added MOCK_TOTAL_COUNT for app-wide display consistency
// ============================================================

// Re-export everything from demoOpportunities
export * from './demoOpportunities';

// Explicit re-exports with legacy names for backward compatibility
export { 
  DEMO_OPPORTUNITIES as MOCK_OPPORTUNITIES,
  DEMO_CATEGORIES as CATEGORIES,
  DEMO_METADATA,
  getOpportunityById,
  getOpportunitiesInOrder,
  getTopOpportunities,
  getOpportunitiesByCategory,
  calculatePortfolioTotals,
  formatCurrency,
  getPortfolioSummary,
} from './demoOpportunities';

// Re-export Opportunity type with explicit naming
export type { Opportunity, UseCaseCategory } from './demoOpportunities';

// ============================================================
// DISPLAY COUNT
// Reflects the full initiative library size (174 use cases in
// claude_code_files/DVA_Use_Case_Library.csv). Use this constant
// anywhere the app displays a total initiative count so the number
// stays consistent across pages and components.
// ============================================================
export const MOCK_TOTAL_COUNT = 174;